import {
  ClientInstanceRolesApi,
  ClientInstancesApi,
  ClientInstanceUsersApi,
  ClientsApi,
  ClientUsersApi,
  Configuration,
  InstancesApi,
  UsersApi
} from '@skynamo/license_service_api'
import { createServiceApiConfiguration, type ErrorInterceptor } from '@shared/services/svc-api/serviceApiConfiguration'

export class LicenseApiSingleton {
  public static async getClientsApiInstance(onError?: ErrorInterceptor): Promise<ClientsApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new ClientsApi(config, undefined, instance)
  }

  public static async getClientInstancesApiInstance(onError?: ErrorInterceptor): Promise<ClientInstancesApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new ClientInstancesApi(config, undefined, instance)
  }

  public static async getClientInstanceUsersApiInstance(onError?: ErrorInterceptor): Promise<ClientInstanceUsersApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new ClientInstanceUsersApi(config, undefined, instance)
  }

  public static async getClientUsersApiInstance(onError?: ErrorInterceptor): Promise<ClientUsersApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new ClientUsersApi(config, undefined, instance)
  }

  public static async getClientInstanceRolesApiInstance(onError?: ErrorInterceptor): Promise<ClientInstanceRolesApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new ClientInstanceRolesApi(config, undefined, instance)
  }

  public static async getInstancesApiInstance(onError?: ErrorInterceptor): Promise<InstancesApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new InstancesApi(config, undefined, instance)
  }

  public static async getUsersApiInstance(onError?: ErrorInterceptor): Promise<UsersApi> {
    const { config, instance } = await this.getConfiguration(onError)
    return new UsersApi(config, undefined, instance)
  }

  private static async getConfiguration(onError?: ErrorInterceptor) {
    const { params, instance } = await createServiceApiConfiguration('license', onError)
    return { config: new Configuration(params), instance }
  }
}

export function validateStatusForCollectionEndpoint(status: number) {
  return (status >= 200 && status < 300) || status === 404
}
